<div class="common-text-input__container-field-sequential">
  <field-sequential-header [field]="field"></field-sequential-header>
  @if (field.multiline){
    <label class="common-text-input__block-field-textarea-sequential"
      [ngClass]="{'common-text-input__block-field-textarea-sequential--error': field.error }"
      [attr.disabled]="field.noEditable?true:null"
      [for]="'field-type-text-'+field.id">
      <textarea class="common-text-input__input-sequential"
        [id]="'field-type-text-'+field.id"
        [name]="'field-type-text-'+field.id"
        [placeholder]="'common.write-here' | afTranslate"
        [(ngModel)]="fieldTypeText.inputText"
        (blur)="changeInField()"
        [disabled]="field.noEditable">
      </textarea>
    </label>
  }@else {
    <label class="common-text-input__block-field-input-sequential"
      [ngClass]="{'common-text-input__block-field-input-sequential--error': field.error }"
      [attr.disabled]="field.noEditable?true:null"
      [for]="'field-type-text-'+field.id">
      <input class="common-text-input__input-sequential"
        type="text"
        autocomplete="off"
        [id]="'field-type-text-'+field.id"
        [name]="'field-type-text-'+field.id"
        [maxlength]="field.maxLength?field.maxLength:null"
        [placeholder]="field.noEditable?'':('common.write-here' | afTranslate)"
        [disabled]="field.noEditable"
        [(ngModel)]="fieldTypeText.inputText"
        (blur)="changeInField()"
        (keyup.enter)="enterChangeInField($event)"/>
    </label>
  }
  @if (field.error) {
    <div class="common-text-input__mandatory-tag">
      @if (field.blocker) {
        <i class="lf-icon-warning common-icon__error-md"></i>
      }
      @if (field.errorText) {
        <span>{{field.errorText}}</span>
      }@else {
        <span [afTranslate]="field.blocker?'common.field-mandatory-blocking':'common.field-mandatory'">Campo obligatorio</span>
      }
    </div>
  }
</div>
